<template>
  <div class="app-container">
    <Container
      :title="t('pay.paymentStatement')"
    >
      <template #main>
        <el-tabs
          class="receipt-tabs"
          type="card"
          v-if="!listLoading"
          v-model="activeCode"
        >
          <el-tab-pane
            v-for="(item, index) in bankList"
            :key="index"
            :label="item.name"
            :name="item.code"
            lazy
          >
            <ZHTransactionRecordHistoryTab
              v-if="item.name.includes('中国银行')"
              :bank-code="item.code"
              :bank-account="item.account"
              :isActive="activeCode===item.code"
            />
            <XYTransactionRecordHistoryTab
              v-if="item.name.includes('兴业银行')"
              :bank-code="item.code"
              :bank-account="item.account"
              :isActive="activeCode===item.code"
            />
            <JHTransactionRecordHistoryTab
              v-if="item.name.includes('建设银行')"
              :bank-code="item.code"
              :bank-account="item.account"
              :isActive="activeCode===item.code"
            />
          </el-tab-pane>
        </el-tabs>
      </template>
    </Container>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, toRefs } from 'vue'
import Container from '@/components/form/container/Container.vue'
import { useI18n } from 'vue-i18n'
import ZHTransactionRecordHistoryTab from '@/views/pay/tabs/ZHTransactionRecordHistoryTab.vue'
import XYTransactionRecordHistoryTab from '@/views/pay/tabs/XYTransactionRecordHistoryTab.vue'
import JHTransactionRecordHistoryTab from '@/views/pay/tabs/JHTransactionRecordHistoryTab.vue'
import { getBankInfoForReceiptList } from '@/apis/main-data/company'

export default defineComponent({
  name: 'PaymentSlipStatement',
  components: {
    Container,
    ZHTransactionRecordHistoryTab,
    XYTransactionRecordHistoryTab,
    JHTransactionRecordHistoryTab
  },
  setup() {
    const { t } = useI18n()
    const dataMap = reactive({
      activeCode: '',
      bankList: Array<any>(),
      listLoading: true
    })
    const getBankList = async() => {
      dataMap.listLoading = true
      const data = await getBankInfoForReceiptList()
      if (data && data.data && data.data.length > 0) {
        data.data.forEach(item => {
          if (item.name.includes('中国银行') || item.name.includes('兴业银行') || item.name.includes('建设银行')) {
            dataMap.bankList.push({
              name: item.name,
              code: item.code,
              account: item.account
            })
          }
        })
        dataMap.activeCode = dataMap.bankList[0].code
      } else {
        dataMap.bankList = []
      }
      setTimeout(() => {
        dataMap.listLoading = false
      }, 0.5 * 1000)
    }
    onMounted(() => {
      getBankList()
    })
    return {
      t,
      ...toRefs(dataMap)
    }
  }
})
</script>

<style
  scoped
  lang="scss"
>
.receipt-tabs > .el-tabs__content {
  padding: 32px;
  color: #6b778c;
  font-size: 32px;
  font-weight: 600;
}
</style>
